<template>
<li id="view-settings">
    <a href="/settings/"><i class="fa fa-cogs" ></i> Einstellungen</a>
    <div class="grid-container6">
        <div class="grid-column grid-column3">
            <ul>
                <li>
                    <a href="#"><i class="fa fa-home"></i>{{ $label('operator.operator') }}</a>
                </li>
                <li>
                    <a href="#"><i class="fa fa-list-alt"></i>{{ $label('courses.settings') }}</a>
                </li>
                <li>
                    <a href="#"><i class="fa fa-group"></i>{{ $label('groups.groups') }}</a>
                </li>
                <li>
                    <a href="#"><i class="fa fa-maxcdn"></i>{{ $label('groups.memberships') }}</a>
                </li>
                <!-- <li class="form-disabled"><a><i class="fa fa-cog"></i> Disabled entry</a></li> -->
            </ul>
        </div>
        <div class="grid-column grid-column3">
            <ul>
                <li>
                    <a href="#"><i class="fa fa-male"></i>{{ $label('staff.staff') }}</a>
                </li>
                <li>
                    <a href="#"><i class="fa fa-exclamation"></i>{{ $label('venuzle-info') }}</a>
                </li>
                <!-- <li class="form-disabled"><a><i class="fa fa-user"></i>Disabled right</a></li> -->
                <li><a>&nbsp;</a></li>
                <li><a>&nbsp;</a></li>
            </ul>
        </div>
    </div>
</li>
</template>

<script>
export default {
    //
}
</script>
